/* eslint-disable */
import { I18N_LANGS } from '../../Constants/I18n/I18n.constants';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the `lang` returned from logging in is unknown
 * @export
 * @class AuthOktaUnknownLangTypError
 * @extends {Error}
 */
export class AuthOktaUnknownLangTypError extends Error {
  /**
   * Creates an instance of AuthOktaUnknownLangTypError
   * @param {string} message The Error `message`
   * @memberof AuthOktaUnknownLangTypError
   */
  constructor(message) {
    super(message);
    this.name = `AuthOktaUnknownLangTypError`;
  }
}

/**
 * Called when the `lang` returned from logging in is unknown
 * @param {any} lang The invalid `lang`
 * @returns {never} never
 */
const throwAuthOktaUnknownLangTypeError = (lang) => {
  if (I18N_LANGS.length === 0) {
    throw new AuthOktaUnknownLangTypError(
      stripIndent(`
      Expected "lang" to be transformable to "${I18N_LANGS[0]}".
      Got: "${lang}"
      `),
    );
  }
  const startLangs = I18N_LANGS.slice(0, -1);
  const endLang = I18N_LANGS.slice(-1)[0];
  throw new AuthOktaUnknownLangTypError(
    stripIndent(`
    Expected "lang" to be transformable to one of "${startLangs.join(`", "`)}", or "${endLang}".
    Got: "${lang}"
    `),
  );
};

export default throwAuthOktaUnknownLangTypeError;
